import { EmploymentType } from '../../../Types/Portfolio/EmploymentType';

export const CommunityLegalServices: EmploymentType = {
	company: 'Community Legal Services',
	position: 'Student Supervisor',
	objective: 'A student-run Legal Aid clinic overseen by licensed lawyers.',
	logo: 'https://assets.dear-ux.com/faizhirani/images/logos/cls.jpg',
};
